import {
  EDITOR_CREATE_PAGE_SNAPSHOT_BEGIN,
  EDITOR_CREATE_PAGE_SNAPSHOT_SUCCESS,
  EDITOR_CREATE_PAGE_SNAPSHOT_FAILURE,
  EDITOR_CREATE_PAGE_SNAPSHOT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createPageSnapshot(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_CREATE_PAGE_SNAPSHOT_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/page-snapshots`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_CREATE_PAGE_SNAPSHOT_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Page Snapshot on builder');
          toast.success('Page Snapshot Created Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_CREATE_PAGE_SNAPSHOT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create Page Snapshot on builder');
          toast.error('Page Snapshot Creation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreatePageSnapshotError() {
  return {
    type: EDITOR_CREATE_PAGE_SNAPSHOT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_CREATE_PAGE_SNAPSHOT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createPageSnapshotPending: true,
        createPageSnapshotError: null,
      };

    case EDITOR_CREATE_PAGE_SNAPSHOT_SUCCESS:
      // The request is success
      return {
        ...state,
        createPageSnapshotPending: false,
        createPageSnapshotError: null,
        showPageSnapshotName: false,
        pageSnapshots: [...state.pageSnapshots, action.data],
      };

    case EDITOR_CREATE_PAGE_SNAPSHOT_FAILURE:
      // The request is failed
      return {
        ...state,
        createPageSnapshotPending: false,
        createPageSnapshotError: action.data.error,
      };

    case EDITOR_CREATE_PAGE_SNAPSHOT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createPageSnapshotError: null,
      };

    default:
      return state;
  }
}
